import * as moment from 'moment-timezone'
import { getCountries, getCountry } from '@/services/country'

const announcementsModel = vm => ({
  title: vm.$gettext('Announcements'),
  endpoint: 'announcements',
  allowNew: true,
  shared: false,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Country ISO code'),
      type: 'select',
      options: 'countries',
      showKey: 'iso_code',
      showField: 'name',
      withSelect: true,
      default: getCountry() || null
    },
    {
      key: 'app',
      label: vm.$gettext('App'),
      sortable: false,
      editable: true,
      required: true,
      type: 'select',
      options: [
        {
          value: 'dashboard',
          text: vm.$gettext('Dashboard')
        },
        {
          value: 'dashboard_external',
          text: vm.$gettext('External Tracking Page')
        }
      ],
      withSelect: true,
      default: null,
      description: vm.$gettext('Client app where the announcement must be shown')
    },
    {
      key: 'date_from',
      label: vm.$gettext('From Date'),
      sortable: true,
      editable: true,
      required: true,
      type: 'datetime',
      formatter: (value, key, item) => {
        const tz = getCountries().find(x => x.iso_code === item.country_iso_code).front_config.i18n.tz
        return moment.utc(value).tz(tz).format('L LT')
      },
      description: vm.$gettext('Date since the announcement applies')
    },
    {
      key: 'date_to',
      label: vm.$gettext('To Date'),
      sortable: true,
      editable: true,
      required: true,
      type: 'datetime',
      formatter: (value, key, item) => {
        const tz = getCountries().find(x => x.iso_code === item.country_iso_code).front_config.i18n.tz
        return moment.utc(value).tz(tz).format('L LT')
      },
      description: vm.$gettext('Date until the announcement applies')
    },
    {
      key: 'message',
      label: vm.$gettext('Message'),
      sortable: true,
      editable: true,
      required: true,
      type: 'textarea',
      description: vm.$gettext('Announcement message')
    },
    {
      key: 'active',
      label: vm.$gettext('Active'),
      sortable: true,
      editable: true,
      required: true,
      type: Boolean,
      description: vm.$gettext('Indicates if the announcement is enabled'),
      default: 1
    }
  ],
  filters: ['id', 'country_iso_code', 'app', 'active']
})

export default announcementsModel
